import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subtitle4',
  templateUrl: './subtitle4.component.html',
  styleUrls: ['./subtitle4.component.scss']
})
export class Subtitle4Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
